'use client'

import { useHeaderTheme } from '@/providers/HeaderTheme'
import React, { useEffect } from 'react'

import type { Page } from '@/payload-types'

import { HeroBlock } from '@/blocks/Hero/Component'

export const CarouselHero: React.FC<Page['hero']> = (hero) => {
  const { setHeaderTheme } = useHeaderTheme()

  useEffect(() => {
    if (hero && hero.type === 'carousel') {
      setHeaderTheme('dark')
    }
  }, [hero, setHeaderTheme])

  if (!hero || hero.type !== 'carousel') {
    return null
  }

  if (!hero.slides || hero.slides.length === 0) {
    return null
  }

  return <HeroBlock hero={hero} />
}
